declare var apiKey: string;
declare var apiUrl: string;
declare var returnUrl: string;
;

/** @jsx jsx */ jsx;
import {jsx} from "@emotion/core";
import React from "react";
import {connect} from "react-redux";
import {IUpdateStateAction, ISetSelectedReasonAction, ISetSelectedUomAction} from "./actions/tagRequestActions";
import {
    ChangeInputEvent,
    ITagRequestProps,
    IReasonOption,
    IUomOption,
    TagRequestActions
} from "./types";
import Select from "react-select";
import axios from "axios";

const options = [
    {value: '1', label: 'Incorrectly Received (Warehouse)'},
    {value: '2', label: 'Incorrect Production Reporting (Production)'},
    {value: '3', label: 'Incorrect Pallet Splitting (Warehouse)'},
    {value: '4', label: 'Other'},
    {value: '5', label: 'Initial Inventory RFID Tagging'},
];

class TagRequest extends React.Component<ITagRequestProps> {
    constructor(props: ITagRequestProps) {
        super(props);
        // Save properties sent from Rails in the wrapper into the store
        this.props.storeTagRequestProps(props);
    }

    componentDidMount(): void {
        if (this.props.uom === '' || this.props.uom === undefined) {
            const option = this.props.storages.filter(option => option.label.includes('CS1'));
            if(option.length !== 0) {
                console.log('option', option[0]);
                this.props.setSelectedUom(option[0]);
                this.props.updateState({uom: option[0].value});
            }
        }
    }

    onChange = (event: ChangeInputEvent) => {
        const newState = {[event.target.name]: event.target.value};
        this.props.updateState(newState);
    };

    onUomChange = (option: IUomOption) => {
        this.props.setSelectedUom(option);
        // this.props.updateState({uom: option.value});
    };

    onReasonChange = (option: IReasonOption) => {
        this.props.setSelectedReason(option);
        // this.props.updateState({reason: option.value});
    };

    onCreateTagRequest = async () => {
        axios.post(apiUrl, {
            api_key: apiKey.replace(/amp;/g, ''),
            storage_unit_id: this.props.uom,
            item_id: this.props.item_id,
            qty: this.props.qty,
            lot: this.props.lot,
            expirated_at: this.props.expirated_at,
            transaction_id: this.props.transaction_id,
            reason: this.props.selectedReason.value,
            uom: this.props.selectedUom.value
        })
            .then(() => {
                location.href = returnUrl;
            })
            .catch(error => {
                alert(error);
            });
    };

    render() {
        console.log('this.props', this.props);
        return (
            <React.Fragment>
                <div>
                    <div className="receive-overlay-wrapper" style={{display: "none"}}/>
                    <div className="mf-table table-responsive col-md-12">
                        <table className="table table-bordered table-striped">
                            <thead className="thead-inverse">
                                <tr>
                                    <th>Item # & Description</th>
                                    <th>BASE UOM</th>
                                    <th>QTY</th>
                                    <th>LOT #</th>
                                    <th>Expiration Date</th>
                                    <th>Correcting Transaction ID #</th>
                                    <th>Select Reason</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{`${this.props.number} ${this.props.description} `}</td>
                                    <td style={{width: '150px'}}>
                                        <Select name="uom"
                                                options={this.props.storages}
                                                blurInputOnSelect={true}
                                                onChange={this.onUomChange}
                                                value={this.props.selectedUom}/>
                                    </td>
                                    <td><input type="number" name="qty"
                                            onChange={this.onChange}/></td>
                                    <td><input type="date" name="lot"
                                            onChange={this.onChange}/></td>
                                    <td><input type="date" name="expirated_at"
                                            onChange={this.onChange}/></td>
                                    <td><input type="text" name="transaction_id"
                                            onChange={this.onChange}/></td>
                                    <td style={{minWidth: '215px'}}>
                                        <Select name="reason"
                                                options={options}
                                                blurInputOnSelect={true}
                                                onChange={this.onReasonChange}
                                                value={this.props.selectedReason}/>
                                    </td>
                                    <td>
                                        <button onClick={this.onCreateTagRequest} className="man-btn man-green-btn">Submit
                                            for Review & Approval
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    item_id: state.generateTag.id,
    qty: state.generateTag.qty,
    lot: state.generateTag.lot,
    expirated_at: state.generateTag.expirated_at,
    transaction_id: state.generateTag.transaction_id,
    selectedReason: state.reasons.selectedReason,
    selectedUom: state.uoms.selectedUom,
    reason: state.reasons.reason,
    uom: state.uoms.uom
});

const mapDispatchToProps = dispatch => ({
    storeTagRequestProps: (props: ITagRequestProps) => dispatch({
        type: TagRequestActions.StoreTagRequestProps,
        payload: props
    } as IUpdateStateAction),
    updateState: (newState: object) => dispatch({
        type: TagRequestActions.UpdateState,
        payload: newState
    } as IUpdateStateAction),
    continue: () => dispatch({
        type: TagRequestActions.Continue
    }),
    setSelectedReason: (reason: IReasonOption) => dispatch({
        type: TagRequestActions.SetSelectedReason,
        payload: reason
    } as ISetSelectedReasonAction),
    setSelectedUom: (uom: IUomOption) => dispatch({
        type: TagRequestActions.SetSelectedUom,
        payload: uom
    } as ISetSelectedUomAction),
});

export default connect(mapStateToProps, mapDispatchToProps)(TagRequest);
